'use strict';

import appStore from "@uw-it-sis/lib-react/lib/AppStore";

import RegToolsStore from "./RegToolsStore";
import api from "./Api";
import {NextAction} from "./AppConstants";

/**
 * This tool provides hooks for modifying data stores and other things.
 *
 * The various hooks work differently depending on where there are used. Some
 * forge new api calls, some modify existing calls, and others modify data
 * stores. The goal is to hook into existing code without rewriting a bunch of
 * stuff, and different scenarios call for different approaches.
 */
class RegToolsInjector {

    /**
     * @returns {boolean} true if this is a pre-prod environment where we can modify things.
     */
    isPreProdEnvironment() {
        return (
            appStore.isDevMode()
            ||
            appStore.getEnvironment() === "dev"
            ||
            appStore.getEnvironment() === "eval"
        )
    }

    /**
     * Forge a new registration call based on the current state of the RegTools form.
     *
     * This creates an entirely new registration call.
     */
    async forgeRegistrationCall(termId) {
        const toolsNextAction = RegToolsStore.regGeneralForm.nextAction;
        if (toolsNextAction === "unset") {
            // By default, just do a regular registration call
            return api.getRegistration(termId);
        } else {
            let blockQueryParam = "";
            if (toolsNextAction === NextAction.BLOCK) {
                let block = RegToolsStore.regGeneralForm.block ?? "1"
                blockQueryParam = `?block=${block}`;
            }
            return appStore.getHttpClient().doGet(`${api.baseUrl}/regdev/registration/${termId}/${toolsNextAction}${blockQueryParam}`, `regdev${toolsNextAction}Registration`);
        }
    }

    /**
     * Generate a query param string for the acknowledge call.
     * @return {string}
     */
    generateAcknowledgeParams() {
        // Return nothing if the override is not set
        if (!RegToolsStore.acknowledgeForm.override) {
            return ""
        }

        let params = {}
        if (RegToolsStore.acknowledgeForm.showAll) {
            params["require_all"] = true
        } else {
            params["require_some"] = "voter"
        }

        if (RegToolsStore.acknowledgeForm.campus) {
            params["campus"] = RegToolsStore.acknowledgeForm.campus
        }

        return "?" + new URLSearchParams(Object.entries(params)).toString()
    }

    injectOptChargesData() {
        // Return nothing if the override is not set
        if (!RegToolsStore.optChargesForm.override) {
            return {}
        }

        // Copy the form data and remove override, since it isn't an opt-charges item
        let dataCopy = {...RegToolsStore.optChargesForm}
        delete dataCopy.override
        return dataCopy
    }
}

export default new RegToolsInjector();
